module.exports = __webpack_public_path__ + "static/media/digdes.4b6bd2b6.png";